//libraries
import _ from 'lodash';

/**
 * Import all constants as an object.
 */
import * as actionType from "../../constants/actionType";


let initialState = {
    tags: [],
    hitDone: false
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
export default function (state, action) {
    state = state || initialState;
    switch (action.type) {
        case actionType.CLIENT_TAGS_LOAD:
            return _.assign({}, state, {
                tags: action.payload,
                hitDone: true
            });
        case actionType.CLIENT_TAGS_RESET:
            return _.assign({}, state, {
                tags: [],
                hitDone: false
            });
        default:
            return state;
    }
}